import { Grid, LinearProgress, Paper } from "@material-ui/core";
import { vendorDashStyle } from "../style";
import { GraphLoader } from "../GraphLoader";
import { useMemo, useState } from "react";
import DropdownFilter from "components/DropdownFilter";
import { arrayToObject } from "utils/object-util";
import FormatService from "services/formatService";

export const VendorComparisonWidget = ({ data = [], isLoading }) => {
    const classes = vendorDashStyle();
    const [selectedVendors, setselectedVendors] = useState([]);

    const handleVendorChange = (idx, vendor) => {
        const updated = [...selectedVendors];
        updated[idx] = vendor;
        setselectedVendors(updated);
    };

    const vendorList = useMemo(() => data?.map(v => ({
        ...v,
        name: v.vendorName,
        id: v.vendorId,
    })));

    return (
        <Paper className={classes.card}>
            <Grid container direction="column" spacing={1}>
                <Grid item className={classes.widgetTitle}>Select Vendors to Compare</Grid>
                <Grid item container spacing={1}>
                    {[0, 1, 2, 3].map(idx => (
                        <Grid item xs={3} key={idx} >
                            <Paper className={classes.vendorCard}>
                                <div className={classes.statTitle}>Vendor {idx + 1}</div>
                                <DropdownFilter
                                    id={`vendor-select-${idx}`}
                                    value={selectedVendors[idx]?.id}
                                    onSelect={v => handleVendorChange(idx, v)}
                                    values={vendorList}
                                    elementType="dropdown"
                                    showEmpty
                                    withTypeAhead
                                    label="Vendor"
                                />
                                <Grid container spacing={1} direction="column">
                                    <Grid item className={classes.statCount}>
                                        {selectedVendors[idx]?.overallScore?.toFixed(2) ?? '0'}
                                    </Grid>
                                    <Grid item className={classes.statCount}>
                                        <LinearProgress
                                            style={{ height: 6, borderRadius: 3 }}
                                            color="primary"
                                            variant='determinate'
                                            size="lg"
                                            value={selectedVendors[idx]?.overallScore ?? 0}
                                        />
                                    </Grid>
                                    <Grid item className={classes.statDesc}>
                                        Avg. Cost Per Service: {FormatService.formatCurrency(selectedVendors[idx]?.avgCost ?? '0')}
                                    </Grid>
                                    <Grid item className={classes.statDesc}>
                                        Rework Rate: {selectedVendors[idx]?.reworkRate ?? '0'}
                                    </Grid>
                                    <Grid item className={classes.statDesc}>
                                        Turnaround Time (hrs): {selectedVendors[idx]?.turnaroundTime?.toFixed(2) ?? '0'}
                                    </Grid>
                                    <Grid item className={classes.statDesc}>
                                        Customer Sat.: {selectedVendors[idx]?.satisfaction ?? '0'}
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
            <GraphLoader loading={isLoading} />
        </Paper>
    )
}